export default __webpack_public_path__ + "20e00b8e5752cbe2da0537d99f5aaf6e.png";